import React from 'react';
import { useTranslation } from 'react-i18next';
import { useResumeHold } from '../../../../queries/scheduleRules';
import { useCustomToast } from '../../../Contexts/ToastContext';
import { makeFmt } from '../../../../schedule/format';

const FALLBACK_TZ = 'Asia/Riyadh';

/**
 * Schedule v4: a person changed this screen by hand during a schedule window, so the schedule is paused. Says so in the wording
 * of the schedule page («يدوي بدل جدول «اسم» حتى ٥:١٢ م») and offers «استئناف الجدول» right there (the same call as the page's
 * «استئناف الجدول الآن»). `paused` = the backend's `schedule_paused` block; nothing renders without one.
 */
export default function SchedulePausedChip({ paused, deviceId, tz, className = 'pp-scr-appchip pause', testId = 'appchip-schedule-paused' }) {
  const { t, i18n } = useTranslation();
  const toast = useCustomToast();
  const resume = useResumeHold();
  if (!paused?.until_local) return null;
  const f = makeFmt(t, (i18n.language || 'ar').startsWith('en') ? 'en' : 'ar');

  const onResume = async () => {
    try {
      await resume.mutateAsync([deviceId]);
      toast?.showToast('success', t('sch6.title'), t('sch6.t_resumed'));
    } catch (e) {
      toast?.showToast('error', t('sch6.title'), t('screen.schedule_resume_failed'));
    }
  };

  return (
    <>
      <span className={className} data-testid={testId}>{f.heldChipTxt(paused, tz || FALLBACK_TZ)}</span>
      <button type="button" className="pp-scr-chipbtn" data-testid="schedule-resume" onClick={onResume} disabled={resume.isLoading}>
        {t('screen.schedule_resume')}
      </button>
    </>
  );
}
